import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {FilterStorageService} from '../../services/filter-storage.service';
import {UpdateProductRequestModel} from '../../api/update-product-request-model';
import {ProductModel} from '../../api/product-model';
import {ProductsService} from '../../api/products.service';
import {ProgressService} from '../../controls/progress.service';

@Component({
  selector: 'app-product-edit',
  templateUrl: './product-edit.component.html',
  styleUrls: ['./product-edit.component.scss']
})
export class ProductEditComponent implements OnInit {
  item: UpdateProductRequestModel;
  routeItem: ProductModel;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private products: ProductsService,
              private filters: FilterStorageService,
              private progress: ProgressService) { }

  ngOnInit() {
    this.route.data
      .subscribe((data: { product: ProductModel }) => {
        console.log(data);
        this.routeItem = data.product;
        this.item = {
          executorId: 'notemptystring',
          name: this.routeItem.name,
          size: this.routeItem.size
        };
      });
  }

  async saveData() {
    if (!this.validate()) {
      return ;
    }

    this.progress.show();

    try {
      await this.products.update(this.filters.getSelectedOrganization().id, this.routeItem.id, this.item).toPromise();
      this.goBack();
    } catch (e) {
      alert(e.error.message);
      console.error(e);
    } finally {
      this.progress.hide();
    }
  }

  goBack() {
    this.router.navigate(['..'], {relativeTo: this.route});
  }

  private validate() {
    if (this.item.size < 1) {
      alert('Size should be 1 or greater');
      return false;
    }

    if (this.item.name == null || this.item.name.trim() === '') {
      alert('Specify name');
      return false;
    }

    return true;
  }
}
